import { render, staticRenderFns } from "./checkList3.vue?vue&type=template&id=a829aa72&scoped=true&"
import script from "./checkList3.vue?vue&type=script&lang=js&"
export * from "./checkList3.vue?vue&type=script&lang=js&"
import style0 from "./checkList3.vue?vue&type=style&index=0&id=a829aa72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a829aa72",
  null
  
)

export default component.exports